import React, { useEffect, useState } from "react";
import FailedModal from "../../../CustomModal/Failed";
import Loader from "../../../../Loader/Loader";
import DashboardMenu from "../../../layout/dashboardMenu";
import Header from "../../../layout/header";
import { toast } from "react-toastify";
import SuccessModal from "../../../CustomModal/Success";
import DistanceCalculator from "../../../DistanceCalculator/Calculator";
import useLatLng from "../../../../hooks/uselatlng/uselatlng";
import useSiteDistance from "../../../../hooks/currentlocation/useSiteDistance";
import { VALET_PROJECT_LIST, isNewLeadX } from "../../../../utils/redirection";

const CreateMeeting = ({
  history,
  match,
  activityTypesDetails = [],
  activityTypes,
  getExistingSites,
  markAttendance,
  documentUploadUrlPublic,
  documentUrlDataPublic,
  existingSiteDetails = [],
  saveSiteVisit,
  siteVisit = [],
  projectById = [],
  attendance = []
}) => {
  let siteDistance = useSiteDistance(
    existingSiteDetails?.data?.resultSets[0]?.latitude,
    existingSiteDetails?.data?.resultSets[0]?.longitude
)
  const [isLoading, setIsLoading] = useState(false);
  const [isAllow, setIsAllow] = useState(false);
  const [openCheckIn, setOpenCheckIn] = useState(true);
  const [activityTypeId, setActivityTypeId] = useState("");
  const islatlng = useLatLng();
  var now = new Date();
  now.setMinutes(now.getMinutes() - now.getTimezoneOffset());
  const [currentDate, setCurrentDate] = useState(
    now.toISOString().slice(0, 16)
  );
  const [inputList, setInputList] = useState([
    {
      activity_type_id: "",
      activity_date: "",
      lat: "",
      long: "",
      next_activity_type_id: "",
      next_activity_date: "",
      description: "",
      tagged_along: "",
      meta_data: {},
      spoc_details: {}
    },
  ]);
  const [selectedMeetingType, setSelectedMeetingType] = useState("");
  const [isPopupSubmitted, setIsPopupSubmitted] = useState(false);
  const [showSiteVisitChecklist, setShowSiteVisitChecklist] = useState(false);
  const [isSuccessModalOpen, setIsSuccessModalOpen] = React.useState(false);
  const [isFailedModalOpen, setIsFailedModalOpen] = useState(false);
  const [countToOpenModal, setCountToOpenModal] = useState(0);
  const [distance, setDistance] = useState(0);
  const [userLat, setUserLat] = useState(0)
  const [userLong, setUserLong] = useState(0)


  const [formData, setFormData] = useState({
    meetingType: "",
    clientName: "",
    meetingTime: "",
    spocName: "",
    spocEmail: "",
    mom: "",
  });

  const handleOnlineInput = (key, value) => {
    setFormData((prevState) => ({
      ...prevState,
      [key]: value,
    }));
  };

  // const history = useHistory();

  const handlePopupSubmit = () => {
    setIsPopupSubmitted(true);
  };

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      await activityTypes("is_valet", 0);
      setIsLoading(false);
    })();
  }, []);

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      await getExistingSites("", "", match?.params?.id);
      setIsLoading(false);
    })();
  }, []);

  useEffect(() => {
    setIsFailedModalOpen(false);
    setIsSuccessModalOpen(false);
    if (parseInt(siteVisit?.status) === 200) {
      setIsSuccessModalOpen(true);
      // window.location.href = `dealer-activity-list/${match?.params?.module_id}`
    } else if (
      siteVisit?.status !== undefined &&
      parseInt(siteVisit?.status) !== 200
    ) {
      setCountToOpenModal(countToOpenModal + 1);
      setIsFailedModalOpen(true);
    }
  }, [siteVisit]);

  useEffect(() => {
    // after check in hide popup
    if (attendance?.data !== undefined && attendance?.status === 200) {
      toast.success("Attendance is marked successfully");
      window.location.href =  isNewLeadX()? VALET_PROJECT_LIST : `valet-existing-sites` 
      setOpenCheckIn(false);
      // if (checkInText === "Check out") {
      //     window.location.href = `ba-activity-list/${match?.params?.lead_id}`
      // }
    } else if(attendance?.status !== 200){
      toast.error(attendance?.message)
    }
  }, [attendance]);

  const handleInput = (key, val, metaKey, e) => {
    let list = [...inputList];
    if (key === "meta_data") {
      if (e.target !== undefined && e.target.selectedOptions !== undefined) {
        let desc = e.target.selectedOptions[0].text;
        inputList[0][key][metaKey] = desc;
        inputList[0][key][metaKey + "_id"] = val;
      } else {
        
        inputList[0][key][metaKey] = val;
      }
    } else if(key === "spoc_details"){
      if (e.target !== undefined && e.target.selectedOptions !== undefined) {
        let desc = e.target.selectedOptions[0].text;
        inputList[0][key][metaKey] = desc;
        inputList[0][key][metaKey + "_id"] = val;
      } else {
        inputList[0][key][metaKey] = val;
      }
    } else {
      inputList[0][key] = val;
    }
    setInputList(list);
  };

  const handleSubmissionSuccess = () => {
    setIsLoading(true);
    setShowSiteVisitChecklist(true);
    window.location.href =  isNewLeadX()? VALET_PROJECT_LIST : `valet-existing-sites` 
    setIsLoading(false);
  };

  const handleAlreadyCheckin = () => {
    toast.error("Please check out from last activity");
    setOpenCheckIn(false);
  }

  // Function to calculate distance between two points using Haversine formula
  function haversineDistance(lat1, lon1, lat2, lon2) {
    const R = 6371;
    const dLat = ((lat2 - lat1) * Math.PI) / 180;
    const dLon = ((lon2 - lon1) * Math.PI) / 180;
    const a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos((lat1 * Math.PI) / 180) *
        Math.cos((lat2 * Math.PI) / 180) *
        Math.sin(dLon / 2) *
        Math.sin(dLon / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    const distance = R * c;
    return distance;
  }

  

  // useEffect(() => {
  //   const userLat = parseFloat(islatlng?.lat);
  //   const userLng = parseFloat(islatlng?.lng);
  //   const siteLatNum = parseFloat(
  //     existingSiteDetails?.data?.resultSets[0]?.latitude
  //   );
  //   const siteLngNum = parseFloat(
  //     existingSiteDetails?.data?.resultSets[0]?.longitude
  //   );

  //   if (
  //     !isNaN(userLat) &&
  //     !isNaN(userLng) &&
  //     !isNaN(siteLatNum) &&
  //     !isNaN(siteLngNum)
  //   ) {
  //     // const distance = 0;
  //       const distance = haversineDistance(userLat, userLng, siteLatNum, siteLngNum);

  //     if (distance < 0.5) {
  //       setIsAllow(true);
  //     } else {
  //       setIsAllow(false);
  //     }
  //   }
  // }, [islatlng, existingSiteDetails]);

      useEffect(() => {
        if (existingSiteDetails?.data !== undefined && existingSiteDetails?.data?.resultSets[0] && existingSiteDetails?.data?.resultSets[0]?.latitude !== undefined && existingSiteDetails?.data?.resultSets[0]?.longitude ) {
            let distanceDis = 0;
            if(siteDistance?.distance_in_km && siteDistance?.distance_in_km !== 'NaN'){
              distanceDis = siteDistance?.distance_in_km * 1000;
              setUserLat(siteDistance?.curr_lat)
              setUserLong(siteDistance?.curr_long)
                setDistance(distanceDis)
            }

            // if(parseInt(distanceDis) > 500){
            //   setIsAllow(false)
            // } else{
            //   setIsAllow(true)
            // }
            setTimeout(() => {
                setIsLoading(true)
                setIsLoading(false)
            }, 1000)
        }
    }, [existingSiteDetails, siteDistance])

  const handleSubmit = async (e) => {
    e.preventDefault();
    let list = inputList[0];
    list["valet_project_id"] = match?.params?.id;
    list['site_name'] = existingSiteDetails?.data?.resultSets[0]?.project_name;
    list['spoc_details']['meeting_time'] = currentDate;
    list['meeting_type'] = selectedMeetingType;
    list['activity_type_id'] = activityTypeId;
    list['lat'] = siteDistance?.curr_lat ?? islatlng?.lat
    list['long'] = siteDistance?.curr_long ?? islatlng?.lng
    if (list["long"] == null || list["lat"] == null) {
      toast.error("Please enable your location");
      return false;
    }

    if (list?.meta_data?.mom!== undefined && list?.meta_data?.mom.length < 60) {
      toast.warning("MOM must be minimum 60 words")
      return false
    }
    setIsLoading(true);
    await saveSiteVisit(list);
    setIsLoading(false);
  };
  

  const handleCardSubmit = () => {
    window.location.href = `valet-existing-sites`
  }


  const handleSelectMeeting = (id) => {
    if(parseInt(id) === 47 && parseInt(distance) > 500){
      setIsAllow(false)
      toast.error("You are outside the geofence!")
    } else{
      setIsAllow(true)
    }
  }

  return (
    <>
     <SuccessModal
        isOpen={isSuccessModalOpen}
        msg={siteVisit?.message}
        url={`site-visit-list/${match?.params?.id}`}
      />

      <FailedModal
        isOpen={isFailedModalOpen}
        msg={siteVisit?.message}
        countToOpenModal={countToOpenModal}
      />

      <Loader isLoading={isLoading} />

      <div id="wrapper">
        <DashboardMenu />
        <div id="content-wrapper" className="d-flex flex-column">
          <div id="content">
            <Header title={"Create Meeting"} history={history} />
            {/*BODY*/}
            <div className="container-fluid common-bg">
              <>
                <form>
                  <div className="row">
                    <div className="col-md-12">
                      <>
                        <div className="d-sm-flex align-items-center justify-content-between com-sub-heading">
                          <h1 className="h3 mb-0 text-black-100">
                            {`${parseFloat(distance).toFixed(2)} meter away from site. current lat ${userLat} and long ${userLong}`}
                          </h1>
                        </div>
                        <div className="card-body bg-white">
                          <div className="user">
                            <div className="form-group row">
                              <div
                                className="col-sm-6 mt-1 float-field"
                                style={{
                                  marginTop: "16px !important",
                                }}
                              >
                                <select
                                  className="form-control form-control-user"
                                  onChange={(e) => {
                                    setActivityTypeId(e.target.value);
                                    handleSelectMeeting(e.target.value)
                                  }}
                                >
                                  <option value="">Select Activity</option>
                                  {activityTypesDetails &&
                                    activityTypesDetails?.data !== undefined &&
                                    activityTypesDetails?.data.map((val) => {
                                      return (
                                        <>
                                          {parseInt(activityTypeId) ===
                                          val?.id ? (
                                            <option
                                              value={val?.id}
                                              selected={true}
                                            >
                                              {val.name}
                                            </option>
                                          ) : (
                                            <option value={val?.id}>
                                              {val.name}
                                            </option>
                                          )}
                                        </>
                                      );
                                    })}
                                </select>
                                <label className="large-label float-lb">
                                  Create Meeting
                                </label>
                              </div>
                            </div>
                          </div>
                        </div>
                      </>
                    </div>
                  </div>
                </form>
                {parseInt(activityTypeId) === 47 && (
                  <>
                    {isAllow && (
                      <div className="popup-box">
                        <div className="box">
                          <DistanceCalculator
                            isMapShow={true}
                            calculateDistance={markAttendance}
                            moduleType={"valet"}
                            checkInText={"Check In"}
                            documentUploadUrlPublic={documentUploadUrlPublic}
                            documentUrlDataPublic={documentUrlDataPublic}
                            onSuccess={handleSubmissionSuccess}
                            module_name={"valet"}
                            // onError={handleAlreadyCheckin}
                            valetProjectId={match?.params?.id}
                          />
                        </div>
                      </div>
                    )}
                  </>
                )}


                {/* {showSiteVisitChecklist && (
                  <div className="row">
                  <div className="col-md-12">
                    <div className="d-sm-flex align-items-center justify-content-between com-sub-heading">
                      <h1 className="h3 mb-0 text-black-100">
                        Site Visit Checklist
                      </h1>
                    </div>
                    <div className="card-body bg-white">
                      <div className="user">
                        <div className="form-group row">
                          <div className="col-md-6">
                            <input
                              type="text"
                              value={existingSiteDetails?.data?.resultSets[0]?.project_name}
                              className="form-control form-control-user"
                              disabled
                            />
                            <label className="large-label float-lb">
                              Site Name {" "}
                            </label>
                          </div>
                          <div className="col-md-6">
                            <select
                              className="form-control form-control-user"
                              value={existingSiteDetails?.data?.resultSets[0]?.city}
                              disabled
                            >
                              <option value="">Select city</option>
                              <option value={existingSiteDetails?.data?.resultSets[0]?.city}>
                              {existingSiteDetails?.data?.resultSets[0]?.city}
                              </option>
                            </select>
                            <label className="large-label float-lb">
                              City {" "}
                            </label>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-12 mt-4 d-flex">
                          <button
                            className="btn btn-primary btn-user btn-block submit-btn"
                            onClick={handleCardSubmit}
                          >
                            Submit
                          </button>
                        </div>
                    </div>
                  </div>
                </div>
                )} */}
                {parseInt(activityTypeId) === 48 && (
                  <div className="col-md-12">
                    <div>
                      <div className="d-sm-flex align-items-center justify-content-between com-sub-heading">
                        <h1 className="h3 mb-0 text-black-100">
                          Online Meeting
                        </h1>
                      </div>
                      <div className="card-body bg-white">
                        <div className="user">
                          <div className="col-sm-6 mtk-1 d-mtk-2 float-field mb-4">
                            <input
                              type="text"
                              className="form-control form-control-user"
                              value={
                                existingSiteDetails?.data?.resultSets[0]
                                  ?.project_name
                              }
                              onChange={(e) => {
                                handleInput(
                                  "meta_data",
                                  existingSiteDetails?.data?.resultSets[0]
                                  ?.project_name,
                                  "site_name",
                                  e
                                );
                              }}
                              disabled
                              id="clientName"
                              required
                            />
                            <label className="large-label float-lb">
                              Client Name{" "}
                              <i className="bi bi-asterisk astrick-icon"></i>
                            </label>
                          </div>
                          <div className="col-sm-6 mtk-075 float-field">
                            <input
                              type="datetime-local"
                              className="form-control form-control-user"
                              onChange={(e) => {
                                handleInput(
                                  "meta_data",
                                  currentDate,
                                  "meeting_time",
                                  e
                                );
                              }}
                              disabled
                              my-date-format={"DD/MM/YYYY, HH:mm:ss"}
                              id="validationCustom01"
                              min={
                                new Date().toISOString().split("T")[0] +
                                "T00:00"
                              }
                              value={currentDate}
                            />
                            <label className="large-label float-lb">
                              Meeting Time
                            </label>
                          </div>
                          <div className="col-sm-6 mtk-1 d-mtk-2 float-field mb-4">
                            <input
                              type="text"
                              className="form-control form-control-user"
                              onChange={(e) => {
                                handleInput(
                                  "spoc_details",
                                  e.target.value,
                                  "spoc_name",
                                  e
                                );
                              }}
                              id="validationCustom01"
                              required
                            />
                            <label className="large-label float-lb">
                              SPOC Name{" "}
                              <i className="bi bi-asterisk astrick-icon"></i>
                            </label>
                          </div>
                          <div className="col-sm-6 mtk-1 d-mtk-2 float-field mb-4">
                            <input
                              type="email"
                              className="form-control form-control-user"
                              onChange={(e) => {
                                handleInput(
                                  "spoc_details",
                                  e.target.value,
                                  "spoc_email",
                                  e
                                );
                              }}
                              id="validationCustom01"
                              required
                            />
                            <label className="large-label float-lb">
                              SPOC Email{" "}
                              <i className="bi bi-asterisk astrick-icon"></i>
                            </label>
                          </div>
                          <div className="col-sm-6 mtk-075 float-field mb-4">
                            <textarea
                              className="form-control form-control-user"
                              placeholder="MOM"
                              onChange={(e) => {
                                handleInput(
                                  "meta_data",
                                  e.target.value,
                                  "mom",
                                  e                                
                                );
                              }}
                              id="validationCustom01"
                              rows="4"
                              cols="20"
                              required={true}
                            />
                          </div>
                        </div>
                        <div className="col-md-12 mt-4 d-flex">
                          <button
                            className="btn btn-primary btn-user btn-block submit-btn"
                            onClick={handleSubmit}
                          >
                            Submit
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CreateMeeting;
